import React, {useEffect, useState} from 'react';
import {Checkbox, Drawer} from '@blueprintjs/core';
import styled from 'styled-components';

import {SearchableDataGrid} from "../../../../components/tables/data-grid";
import * as AuthAPI from '../../../../services/auth-api';
import {timeAgo} from "../../../../utils/time";


const DataWrapper = styled.div`
    width: 95%;
    margin: 2em auto;
`;

const userColumns = [
    {key: 'id', name: 'Id', width: 50, sortable: true, filterable: true},
    {key: 'fullName', name: 'Name', resizable: true, sortable: true, filterable: true},
    {key: 'email', name: 'Email', resizable: true, sortable: true, filterable: true},
    {key: 'status', name: 'Status', width: 75, resizable: true, sortable: true, filterable: true},
    {key: 'type', name: 'Type', width: 75, resizable: true, sortable: true, filterable: true},
    {key: 'auth0Id', name: 'Auth0 Id', resizable: true, sortable: true, filterable: true},
    {key: 'primaryOrgName', name: 'Active org', resizable: true, sortable: true, filterable: true},
    {key: 'ownerOrgName', name: 'Owner org', resizable: true, sortable: true, filterable: true},
    {
        key: 'adopted', name: 'Adopted', width: 75, resizable: true,
        formatter: (params) => <Checkbox checked={!!params.row.adopted} readOnly />
    },
    {
        key: 'createdAt', name: 'Created', width: 100, resizable: true, sortable: true,
        formatter: (params) =>
            <span title={params.row.createdAt}>{timeAgo(params.row.createdAt)}</span>,
    },
    {
        key: 'updatedAt', name: 'Updated', width: 100, resizable: true, sortable: true,
        formatter: (params) =>
            <span title={params.row.updatedAt}>{timeAgo(params.row.updatedAt)}</span>,
    },
];


const UsersForRole = ({isOpen, onClose, role, allOrgs}) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        if (!isOpen || !role) return;
        const apiGroup = role.auraAdminOnly ? 'adminRoles_users' : 'roles_users';
        AuthAPI[apiGroup].list(role.id, allOrgs).then(({data: users}) => {
            const getOrgName = (orgId) => {
                const org = allOrgs.find(o => o.id === orgId);
                return org?.name ?? 'Unknown';
            };
            setData(users.map(u => ({
                ...u,
                primaryOrgName: getOrgName(u.primaryOrgId),
                ownerOrgName: getOrgName(u.ownerOrgId),
            })));
        }).catch(e => {
            console.error(e);
            setData([]);
        });

        return () => setData([]);
    }, [isOpen, role, allOrgs]);

    return (
        <Drawer
            size={Drawer.SIZE_LARGE}
            icon="people"
            title={role ? `Role > ${role.name} > Users` : ''}
            isOpen={isOpen}
            onClose={onClose}
        >
            <DataWrapper>
                <SearchableDataGrid
                    columns={userColumns}
                    data={data}
                    defaultSort='fullName'
                />
            </DataWrapper>
        </Drawer>
    );
};

export {UsersForRole};
